module.exports = EventManager;


/*****************
 ** WEBPACK FOOTER
 ** external "EventManager"
 ** module id = 5
 ** module chunks = 2 3
 **/